<template>
  <div class="language-switcher">
    <button class="lang-button" :class="{ active: currentLocale === LOCALES.CROATIAN }"
      @click="changeLanguage(LOCALES.CROATIAN)" title="Hrvatski">
      🇭🇷
    </button>
    <button class="lang-button" :class="{ active: currentLocale === LOCALES.ENGLISH }"
      @click="changeLanguage(LOCALES.ENGLISH)" title="English">
      🇬🇧
    </button>
  </div>
</template>

<script setup lang="ts">
import { useLocaleStore } from '@/stores/locale'
import { LOCALES } from '@/locales'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import i18n from '@/i18n'

const localeStore = useLocaleStore()
const { locale, t } = useI18n()

const currentLocale = computed(() => localeStore.currentLocale)

const changeLanguage = (newLocale: string) => {
  localeStore.setLocale(newLocale)
  locale.value = newLocale

  const testKeys = [
    'establishments.title',
    'navigation.dashboard',
    'establishments.manageEstablishments'
  ]

  console.group('Provjera prijevoda nakon promjene jezika')

  for (const key of testKeys) {
    const translation = t(key)

    if (translation === key) {

    }
  }

  console.groupEnd()
}
</script>

<style scoped>
.language-switcher {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.lang-button {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  padding: 0.25rem;
  border-radius: 4px;
  opacity: 0.6;
  transition: all 0.2s ease;
}

.lang-button:hover {
  opacity: 0.8;
  background-color: #333;
}

.lang-button.active {
  opacity: 1;
  background-color: #333;
}
</style>